import * as React from 'react';
import { useSelector } from 'react-redux';

import { BottomStripe } from '../../components/BottomStripe';
import { IApplicationState } from '../../types/redux';
import { selectEventCategory } from '../../selectors/eventCategory';
import { trackSiteTypeChange } from './tracking';

export const BottomStripeContainer: React.FC = () => {
  const showSiteTypeChanging = useSelector((state: IApplicationState) => state.showSiteTypeChanging);
  const eventCategory = useSelector(selectEventCategory);

  const handleSiteTypeChange = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    trackSiteTypeChange(eventCategory);

    document.cookie = 'flavour=mobile;path=/;domain=.cian.ru';
    location.reload();
  };

  return (
    <BottomStripe
      data-testid="BottomStripe"
      withSiteTypeChanging={showSiteTypeChanging}
      onSiteTypeChange={handleSiteTypeChange}
    />
  );
};
